import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Checkbox, Divider, Grid, ListItem, ListItemText } from "@mui/material";
import type { Dispatch, FC } from "react";
import { useTranslation } from "react-i18next";
import { TextureFilter } from "./TextureFilter";

export interface OpticalMaterialDataFilterProps {
  hasDigitalSamplesValue: boolean | undefined;
  onHasDigitalSamplesValueChange: Dispatch<boolean | undefined>;
  hasLevel3Data: boolean | undefined;
  onHasLevel3DataChange: Dispatch<boolean | undefined>;
  columns?: number;
  isExternal?: boolean;
  onTextureChange?: Dispatch<Array<AutocompleteData>>;
  texture?: Array<AutocompleteData>;
  isLandingPage?: boolean;
}

export const OpticalMaterialDataFilter: FC<OpticalMaterialDataFilterProps> = ({
  hasDigitalSamplesValue,
  onHasDigitalSamplesValueChange,
  hasLevel3Data,
  onHasLevel3DataChange,
  columns = 12,
  isExternal = false,
  texture,
  onTextureChange,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: ToBeEvaluated with the team
  isLandingPage = false,
}) => {
  const { t } = useTranslation();
  return (
    <Grid mt={-2} mb={2} container spacing={2} columns={columns}>
      <Grid size={{ xs: 12, lg: 6, xl: 3 }}>
        <TextureFilter t={t} value={texture} onChange={onTextureChange} />
      </Grid>
      <Grid size={{ xs: 12, lg: 6, xl: 3 }}>
        <Divider sx={{ marginTop: "8px", marginBottom: "8px" }}></Divider>
      </Grid>
      {!isExternal ? (
        <Grid size={{ xs: 12, lg: 6, xl: 3 }}>
          <ListItem
            sx={(theme) => ({ border: `1px solid ${theme.palette.divider}` })}
            secondaryAction={
              <Checkbox
                onChange={(e) =>
                  onHasDigitalSamplesValueChange(
                    e.target.checked ? true : undefined,
                  )
                }
                checked={hasDigitalSamplesValue === true}
              />
            }
          >
            <ListItemText>{t("filter_omd_digital_samples")}</ListItemText>
          </ListItem>
        </Grid>
      ) : null}
      <Grid size={{ xs: 12, lg: 6, xl: 3 }}>
        <ListItem
          sx={(theme) => ({
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "4px",
          })}
          secondaryAction={
            <Checkbox
              onChange={(e) =>
                onHasLevel3DataChange(e.target.checked ? true : undefined)
              }
              checked={hasLevel3Data === true}
            />
          }
        >
          <ListItemText
            secondary={
              isExternal
                ? `${t("filter_omd_item_available_secondary")}`
                : undefined
            }
          >
            {t("filter_omd_item_text")}
          </ListItemText>
        </ListItem>
      </Grid>
    </Grid>
  );
};
